import React, { useRef } from 'react';
import { useClickAway, useMedia } from 'react-use';
import { Menu } from '../components/menu/Menu';

import { Navbar } from '../components/navbar/Navbar';
import { useCXI } from '../useCXI';

import * as Styled from './StyledCXILayout';

export const CXILayout = ({ children }) => {
    const { vars, addVars } = useCXI();
    const { isMenuOpen } = vars;

    const isMobile = useMedia('(max-width: 991px)');
    const menuRef = useRef(null);

    function setMenuOpen(state) {
        addVars({ isMenuOpen: state });
    }

    useClickAway(menuRef, () => {
        if (isMobile && !isMenuOpen) setMenuOpen(false);
    });

    if (vars.simpleLayout === true) {
        return <Styled.SimpleContainer>{children}</Styled.SimpleContainer>;
    }

    return (
        <Styled.Container menuOpen={isMenuOpen}>
            <Navbar menuToggle={() => setMenuOpen(!isMenuOpen)} />
            <Styled.Menu ref={menuRef} menuOpen={isMenuOpen}>
                <Menu />
            </Styled.Menu>
            <Styled.Main>{children}</Styled.Main>
        </Styled.Container>
    );
};
